module.exports = __webpack_public_path__ + "img/9788954428439.6c1007d4.jpg";